export default "__VITE_ASSET__Dxi3qoHf__"